export default "__VITE_ASSET__DQzMWCCH__"